import apiService from './ApiService';

export default class UserApiService {

    /**
     * Register a new user
     * @param newUserInfo {AppUserDTO}
     * @returns {Promise<ServiceResponse<number>>}
     */
    async registerUser(newUserInfo) {
        const response = await apiService.postData('/api/Auth/register', newUserInfo);

        return response.data;
    }

    /**
     * Get all the user's information
     * @param userId {number}
     * @return {Promise<ServiceResponse<AppUserGenericDTO>>}
     */
    async getUserInfo(userId) {
        const response = await apiService.getData('/api/User/' + userId, null);
        return response.data;
    }

    /**
     * Update a user
     * @param userDto {AppUserDTO}
     * @return {Promise<ServiceResponse<boolean>>}
     */
    async updateUserInfo(userDto) {
        const response = await apiService.putData('api/User/', userDto);

        return response.data;
    }

    /**
     * Opt a user in to or out of text messages.
     *
     * Users may opt themselves in or out. An administrator may only opt another user out, since
     * consent has to come from the tenant themselves.
     * @param userId {number}
     * @param optIn {boolean}
     * @return {Promise<ServiceResponse<boolean>>}
     */
    async updateSmsConsent(userId, optIn) {
        const response = await apiService.postData('api/User/sms-consent', { userId, optIn });

        return response.data;
    }

    async getAllUsersGeneric() {
        const response = await apiService.getData('api/User/admin/generic');

        return response.data;
    }
}
